/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import { Button } from '../../components';
import styles from './account-exists.styles.module.css';
import forgotPasswordStyles from '../ForgotPassword/styles.module.css';
import { useConfig } from '../../services/ConfigProvider';
import useTranslation from '../../utils/translation';
import { pushPageViewDataLayer } from '../../services/googleTagManager';
import { CreateAccountResponse, ERROR_TYPES } from './types';

interface Props {
  closePopupFunction?: () => void;
  createUserResponse?: CreateAccountResponse;
}

const AccountExists = ({ createUserResponse, closePopupFunction }: Props) => {
  const config = useConfig();
  const COUNTRY = config?.REACT_APP_COUNTRY || 'BR';

  const translate = useTranslation(COUNTRY);

  const navigate = useNavigate();

  const [showQRCode, setShowQRCode] = useState<boolean>(false);

  useEffect(() => {
    pushPageViewDataLayer('registration - already exists', 'visualizado');
  }, []);

  const handleSendRestorePassword = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.preventDefault();

    navigate('/#forgotpassword');

    if (closePopupFunction != undefined) {
      closePopupFunction();
    }
  };

  const handleClosePopup = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.preventDefault();

    navigate('/');

    if (closePopupFunction != undefined) {
      closePopupFunction();
    }
    setShowQRCode(false);
  };

  const getPopupMessage = (): string | TrustedHTML => {
    if (createUserResponse?.type === ERROR_TYPES.PHONE_ALREADY_EXISTS) {
      return createUserResponse.message;
    }

    if (
      createUserResponse?.type === ERROR_TYPES.TAX_IDENTIFICATION_ALREADY_EXISTS
    ) {
      const messageArray = createUserResponse.message.split('e-mail ');
      const email = messageArray.pop();
      const message = `${messageArray.pop()} e-mail`;
      return `${message}<br/><strong>${email}</strong>`;
    }

    return translate['login-registration-account-exists-desc'];
  };

  const renderQRCode = () => {
    return (
      <div className={forgotPasswordStyles.forgotpass}>
        <p
          className={forgotPasswordStyles.qrCodeTitle}
          dangerouslySetInnerHTML={{
            __html: translate['forgot-password-change-email-title'],
          }}
        />
        <p className={forgotPasswordStyles.qrCodeSubtitle}>
          {translate['forgot-password-qr-code-title']}
        </p>
        <div id="qrCodeDiv" className={forgotPasswordStyles.qrCode}>
          <QRCodeCanvas
            value={createUserResponse?.qrcode_url || ''}
            size={window.innerWidth > 980 ? 128 : 200}
          />
        </div>
        <div className={forgotPasswordStyles.qrCodeActionButton}>
          <Button
            type="submit"
            text={translate['forgot-password-go-back-to-login']}
            onClick={handleClosePopup}
          />
        </div>
      </div>
    );
  };

  const renderRecoveryAccount = () => {
    return (
      <div className={styles.accountExistsError}>
        <h1>
          {createUserResponse?.title &&
          createUserResponse.type !== ERROR_TYPES.EMAIL_ALREADY_EXISTS
            ? createUserResponse.title
            : translate['login-registration-account-exists-title']}
        </h1>

        <p
          dangerouslySetInnerHTML={{
            __html: getPopupMessage(),
          }}
        />
        <div className={styles.form}>
          <footer>
            {createUserResponse?.type ===
              ERROR_TYPES.TAX_IDENTIFICATION_ALREADY_EXISTS && (
              <>
                <div>
                  <Button
                    type="button"
                    text={translate['forgot-password-go-back-to-login']}
                    onClick={handleClosePopup}
                  />
                </div>
                <div>
                  <Button
                    type="button"
                    text={translate['forgot-password-change-email']}
                    onClick={() => setShowQRCode(true)}
                  />
                </div>
              </>
            )}
            {createUserResponse?.type !==
              ERROR_TYPES.TAX_IDENTIFICATION_ALREADY_EXISTS && (
              <>
                <div className={styles.footerButtonWrapper}>
                  <Button
                    type="button"
                    text={translate['login-manual-button-submit-text']}
                    onClick={handleClosePopup}
                  />
                </div>
                <div className={styles.footerButtonWrapper}>
                  <Button
                    type="button"
                    text={
                      translate[
                        'login-registration-account-exists-restore-pass'
                      ]
                    }
                    onClick={handleSendRestorePassword}
                  />
                </div>
              </>
            )}
          </footer>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.accountexists}>
      {showQRCode && renderQRCode()}
      {!showQRCode && renderRecoveryAccount()}
    </div>
  );
};

export default AccountExists;
